import type { UpdateRoleInput } from '@idc-forms/schemas'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { queryKeys } from '@/shared/constants/query-keys'
import { getErrorMessage } from '@/shared/utils/handle-api-error'
import { deleteRole, updateRole } from '../services/roles-admin.service'

export const useUpdateRoleMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, payload }: { id: string; payload: UpdateRoleInput }) =>
      await updateRole(id, payload),
    onSuccess: () => {
      toast.success('Rol actualizado')
      void queryClient.invalidateQueries({ queryKey: queryKeys.roles.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}

export const useDeleteRoleMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => await deleteRole(id),
    onSuccess: () => {
      toast.success('Rol eliminado')
      void queryClient.invalidateQueries({ queryKey: queryKeys.roles.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}
